var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundDone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M14.651 11.666v4.906c0 .467.254.907.654 1.147l4.16 2.467c.48.28 1.093.12 1.373-.347.28-.48.133-1.093-.347-1.373l-3.826-2.28v-4.534c-.022-.546-.467-.98-1.014-.986-.546 0-1 .453-1 1zm13.334 1V5.612c0-.6-.72-.893-1.134-.466l-2.373 2.373c-2.529-2.529-6.053-3.8-9.613-3.467-5.587.507-10.187 5-10.8 10.587-.675 6.517 4.003 12.371 10.51 13.15 6.505.78 12.433-3.804 13.316-10.297.094-.8-.533-1.493-1.333-1.493-.667 0-1.227.493-1.307 1.147-.573 4.653-4.586 8.253-9.4 8.186-4.946-.066-9.12-4.24-9.2-9.2-.08-5.2 4.147-9.466 9.334-9.466 2.573 0 4.906 1.053 6.6 2.733l-2.787 2.787c-.427.426-.133 1.146.467 1.146h7.053c.373 0 .667-.293.667-.666z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundDone);
export default __webpack_public_path__ + "static/media/round-done.126f357e.svg";
export { ForwardRef as ReactComponent };